// extracted by mini-css-extract-plugin
export var content = "_2-3";
export var contentWrapper = "_2-2";
export var fullWidthButton = "_2-4";
export var heroImage = "_2-6";
export var logo = "_2-1";
export var logoContainer = "_2-0";
export var panel = "_2-5";